import Company from './company';
import Misc from './misc';
import ServiceProvider from './service-provider';
import PopularItems from './PopularItems';
import QuickLinks from './QuickLinks';
import Statistics from './Statistics';

export default {
  Company,
  Misc,
  ServiceProvider,
  PopularItems,
  QuickLinks,
  Statistics,
};
